import { render, staticRenderFns } from "./myinformation.vue?vue&type=template&id=5d1ccb53&scoped=true&"
import script from "./myinformation.vue?vue&type=script&lang=js&"
export * from "./myinformation.vue?vue&type=script&lang=js&"
import style0 from "./myinformation.vue?vue&type=style&index=0&id=5d1ccb53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1ccb53",
  null
  
)

export default component.exports